module.exports = __webpack_public_path__ + "img/کارت-ویزیت-پی-وی-سی.b33466a9.png";